const getSenderAddress = () => {
  try {
    const address = JSON.parse(sessionStorage.getItem("SAddress"));
    if (address.id) {
      return address;
    }

    return undefined;
  } catch (error) {
    return undefined;
  }
};

export default getSenderAddress;
